import type { LC_AuthenticateOut, User } from './auth.types';


export interface RexSystem {
  name: string;
  authRedirectUri: string;
  urlBase?: string;
  logo?: string;
  smallLogo?: string;
}

/**
 * Mapea la respuesta de login (transport) a la entidad interna User
 */
export const mapLoginResponseToUser = (r: LC_AuthenticateOut): User => {
  const nombreCompleto = [
    r.employeeFirstName,
    r.employeeLastName,
    r.employeeMotherLastName,
  ].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
  return {
    id: r.userId || '',
    nombres: r.employeeFirstName || '',
    apellidoPaterno: r.employeeLastName || '',
    apellidoMaterno: r.employeeMotherLastName || '',
    nombreCompleto,
    companyName: r.companyName || '',
    idEmpresa: r.companyId ?? null,
    idEmpleado: r.employeeId ?? null,
    alternativeKeyEmpresa: r.alternativeCompanyKey || null,
    usernameSuffix: r.usernameSuffix || null,
    syncAssistance: r.syncAssistance ?? false,
    seedAssistance: r.seedAssistance || null,
  };
};

export interface TokenInfo {
  token: string;
  tokenExpiry: string; // ISO string
}

/**
 * Extrae token y fecha de expiración normalizada (ISO) desde la respuesta de login
 */
export const extractTokenInfo = (resp: LC_AuthenticateOut): TokenInfo => {
  const seed = resp.seed;
  if (!seed) return { token: '', tokenExpiry: new Date().toISOString() };
  return { token: seed.token, tokenExpiry: new Date(seed.expiresAt).toISOString() };
};

export interface AuthState {
  user: User | null;
  token: string | null;
  tokenExpiry: string | null; // ISO string
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  isSSO: boolean;
  isInitializing: boolean;
  accountLinkRequired: boolean;
  rexSystems: RexSystem[];
}

export const mapRexSystemsFromResponse = (
  rexSystems: LC_AuthenticateOut['rexSystems'],
): RexSystem[] =>
  (rexSystems ?? [])
    .filter((s) => s.name && s.authRedirectUri)
    .map((s) => ({
      name: s.name!,
      authRedirectUri: s.authRedirectUri!,
      ...(s.urlBase ? { urlBase: s.urlBase } : {}),
      ...(s.logo ? { logo: s.logo } : {}),
      ...(s.smallLogo ? { smallLogo: s.smallLogo } : {}),
    }));
